// extracted by mini-css-extract-plugin
module.exports = {"Container":"BackgroundVideo_Container__2Arbr","Video":"BackgroundVideo_Video__3S-M5","Content":"BackgroundVideo_Content__2yvaV","SubContent":"BackgroundVideo_SubContent__20UFa"};